import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import { ButtonPrimary } from '../ButtonPrimary'
import { useStyles } from './style'

const AlertDialog = ({ title, icon, children, open, onClose, buttonLabel = 'Entendi' }) => {
  const classes = useStyles()
  
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      maxWidth="xs"
      scroll="paper"
      classes={{ paper: classes.dialogPaper }} // Injeta o border-radius e a largura
    >
      <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
        <div className={classes.titleContainer}>
          {icon && <span className={classes.iconWrapper}>{icon}</span>}
          <span className={classes.titleText}>{title}</span>
        </div>
      </DialogTitle>
      
      <DialogContent dividers className={classes.dialogContent}>
        <span className={classes.textMessage}>{children}</span>
      </DialogContent>
      
      <DialogActions className={classes.dialogActions}>
        <ButtonPrimary
          onClick={() => onClose(false)}
          label={buttonLabel}
          color="primary"
        />
      </DialogActions>
    </Dialog>
  )
}

export default AlertDialog